export default __webpack_public_path__ + "static/media/title_sp.2fdb5d90.png";